<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<!-- Enumが配列の場合 -->
		<select
			v-if="selectType == 'array'"
			v-model="model"
			:disabled="disabled"
			class="select w-full"
			tabindex="1"
			@focus="inputFocus"
			@change="inputFocus"
		>
			<option v-if="placeholder" value="">
				{{ placeholder }}
			</option>
			<option
				v-for="(item, value) in enum"
				:key="item.id"
				:value="item.id"
				:selected="item == modelValue"
				:disabled="item.is_disabled == true"
			>
				{{ item.name }}
			</option>
		</select>
		<!-- Enumがオブジェクトの場合 -->
		<select
			v-else
			v-model="model"
			:disabled="disabled"
			class="select w-full"
			tabindex="1"
			@focus="inputFocus"
			@change="inputFocus"
		>
			<option v-if="placeholder" value="">
				{{ placeholder }}
			</option>
			<option
				v-for="(item, value) in enum"
				:key="value"
				:value="value"
				:selected="item == modelValue"
			>
				{{ item }}
			</option>
		</select>
	</div>

	<ErrorText :text="errorText" />
</template>

<script setup>
import Select from "primevue/select";
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, watch, ref, onMounted } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	enum: [String, Object],
	title: String,
	formClass: [String, Array],
	disabled: Boolean,
	required: Boolean,
	placeholder: String,
	selectType: String,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");

/* ---------------------------------------------------------------------------
	バリデーション
---------------------------------------------------------------------------- */

watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	捕捉事項の表示
---------------------------------------------------------------------------- */
function inputFocus() {
	titleActive.value = !titleActive.value;
}
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.select {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 10px 22px 6px 6px;
	border-radius: 5px;
	background-color: $bg-white2;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-color: $primaryColor;
		background-color: rgba(10, 186, 181, 0.2);
	}
	&.error {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&.required {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&.placeholder {
		color: #d9d9d9;
	}
}
select:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .select {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
